/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentDetailsPaymentInternalInvestmentViewModel } from './PaymentDetailsPaymentInternalInvestmentViewModel';
import {
    PaymentDetailsPaymentInternalInvestmentViewModelFromJSON,
    PaymentDetailsPaymentInternalInvestmentViewModelFromJSONTyped,
    PaymentDetailsPaymentInternalInvestmentViewModelToJSON,
} from './PaymentDetailsPaymentInternalInvestmentViewModel';

/**
 * 
 * @export
 * @interface PaymentDetailsInternalInvestmentPaymentViewModel
 */
export interface PaymentDetailsInternalInvestmentPaymentViewModel {
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsInternalInvestmentPaymentViewModel
     */
    amount?: number;
    /**
     * 
     * @type {Date}
     * @memberof PaymentDetailsInternalInvestmentPaymentViewModel
     */
    firstIncomePaymentDate?: Date;
    /**
     * 
     * @type {Array<PaymentDetailsPaymentInternalInvestmentViewModel>}
     * @memberof PaymentDetailsInternalInvestmentPaymentViewModel
     */
    internalInvestments: Array<PaymentDetailsPaymentInternalInvestmentViewModel>;
}

/**
 * Check if a given object implements the PaymentDetailsInternalInvestmentPaymentViewModel interface.
 */
export function instanceOfPaymentDetailsInternalInvestmentPaymentViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "internalInvestments" in value;

    return isInstance;
}

export function PaymentDetailsInternalInvestmentPaymentViewModelFromJSON(json: any): PaymentDetailsInternalInvestmentPaymentViewModel {
    return PaymentDetailsInternalInvestmentPaymentViewModelFromJSONTyped(json, false);
}

export function PaymentDetailsInternalInvestmentPaymentViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDetailsInternalInvestmentPaymentViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount': !exists(json, 'Amount') ? undefined : json['Amount'],
        'firstIncomePaymentDate': !exists(json, 'FirstIncomePaymentDate') ? undefined : (new Date(json['FirstIncomePaymentDate'])),
        'internalInvestments': ((json['InternalInvestments'] as Array<any>).map(PaymentDetailsPaymentInternalInvestmentViewModelFromJSON)),
    };
}

export function PaymentDetailsInternalInvestmentPaymentViewModelToJSON(value?: PaymentDetailsInternalInvestmentPaymentViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Amount': value.amount,
        'FirstIncomePaymentDate': value.firstIncomePaymentDate === undefined ? undefined : (value.firstIncomePaymentDate.toISOString().substr(0,10)),
        'InternalInvestments': ((value.internalInvestments as Array<any>).map(PaymentDetailsPaymentInternalInvestmentViewModelToJSON)),
    };
}

